export const isSportPage = (): boolean => {
    const {pathname} = window.location;

    return Boolean(pathname.match('[\\/]sport($|[\\/])'));
};
